import React from 'react';
import Auxiliary from '../../hoc/Auxiliary';
import moment from 'moment-timezone';

export const FullDateFormat = props => {
  const termTimezone = props.timezone || null;
  let newStart = props.startDate;
  let newEnd = props.endDate;
  let displayStart = moment(newStart).format('MMM[.] DD[,] YYYY');
  let displayEnd = moment(newEnd).format('MMM[.] DD[,] YYYY');

  if (termTimezone && termTimezone?.length > 0) {
    newStart = moment(props.startDate)
      .tz(termTimezone)
      .format();

    displayStart = moment(newStart)
      .tz(termTimezone)
      .format('MMM[.] DD[,] YYYY');

    newEnd = moment(props.endDate)
      .tz(termTimezone)
      .format();

    displayEnd = moment(newEnd)
      .tz(termTimezone)
      .format('MMM[.] DD[,] YYYY');
  }

  return (
    <Auxiliary>
      {displayStart} - {props.addBr ? <br /> : null}
      {displayEnd}
    </Auxiliary>
  );
};
